import { GenericSuspense, LeftSidebar, useRuntimeEnv, useTranslation } from "@harea/component";
import { Outlet } from "react-router-dom";

const AuthLayout = () => {

    const { runtimeEnv } = useRuntimeEnv()
    const t = useTranslation()

    return (
        <div className="min-h-svh">
            <GenericSuspense>
                <Outlet />
            </GenericSuspense>
        </div>
    )
}

export default AuthLayout;